import React, {Component} from 'react';
import PropTypes from 'prop-types';

const $ = window.jQuery;

class ClientDropdown extends Component {
    static propTypes = {
        items: PropTypes.array.isRequired
    };
    static defaultProps = {
        placeholder: 'Выберите значение'
    };
    state = {
        id: 0
    };

    componentDidMount() {
        const {placeholder, onChange, ...props} = this.props;
        this.$el = $(this.el);
        this.$el.select2({
            placeholder,
            minimumInputLength: 0,
            width: "100%",
            language: "ru",
            dropdownParent: this.$el.closest('.modal').length
                ? this.$el.closest('.modal')
                : undefined
        });
        this.$el.on('change', event => {
            onChange(event, [...event.target.options].filter(o => o.selected).map(o => o.value));
        });
    }

    render() {
        const {items, value, onChange, ...props} = this.props;
        return (
            <select ref={el => this.el = el} {...props}>
                {items.map(item =>
                    <option key={item.id} value={item.id}>{item.text}</option>)}
            </select>
        );
    }
}

export default ClientDropdown;


// WEBPACK FOOTER //
// ./src/controls/ClientDropdown.js